/* ──────────────────────────────────────────────────────────────────────────
 * Apollo Bearing Index — URL + local state (IFX.state)
 * assets/interchange-state.js
 *
 * URL: owned params are tab, q, bore, od, width, tol, unit, machineId, view,
 * cmp, brand, cat, mfr, model, family. Everything else in the query string
 * (theme params, utm…) is preserved. Dims are ALWAYS stored in mm; `unit=in`
 * is display-only. The first executed search pushes a history entry, later
 * ones replace it; restoring from the URL never writes.
 *
 * Local (localStorage, try/catch'd): recent searches (≤ 8), saved parts
 * (≤ 40), unit and density preferences.
 * ───────────────────────────────────────────────────────────────────────── */
(function () {
  "use strict";
  var IFX = window.IFX;
  if (!IFX || IFX.state) return;

  var OWNED_PARAMS = ["tab", "q", "bore", "od", "width", "tol", "unit", "machineId", "view", "cmp", "brand", "cat", "mfr", "model", "family"];
  var RECENT_MAX = 8;
  var SAVED_MAX = 40;

  var didPushState = false;
  var restoring = false;
  var listeners = [];

  function read() {
    var sp = new URLSearchParams(location.search);
    var out = {};
    OWNED_PARAMS.forEach(function (p) { if (sp.has(p)) out[p] = sp.get(p); });
    return out;
  }

  function write(state, opts) {
    opts = opts || {};
    if (restoring) return;
    try {
      var sp = new URLSearchParams(location.search);
      if (!opts.merge) OWNED_PARAMS.forEach(function (p) { sp.delete(p); });
      Object.keys(state).forEach(function (k) {
        var v = state[k];
        if (v == null || v === "") sp.delete(k);
        else sp.set(k, String(v));
      });
      var qs = sp.toString();
      var newUrl = location.pathname + (qs ? "?" + qs : "") + location.hash;
      var hist = { ifx: state };
      if (!didPushState && !opts.replace) { history.pushState(hist, "", newUrl); didPushState = true; }
      else history.replaceState(hist, "", newUrl);
    } catch (err) { /* history API unavailable — non-fatal */ }
  }

  function restore(fn) {
    restoring = true;
    try { fn(read()); } finally { restoring = false; }
  }

  function onPop(fn) {
    listeners.push(fn);
  }
  window.addEventListener("popstate", function () {
    var sp = new URLSearchParams(location.search);
    didPushState = OWNED_PARAMS.some(function (p) { return sp.has(p); });
    var st = read();
    listeners.forEach(function (fn) { restore(function () { fn(st); }); });
  });

  function hasOwnedParams() {
    var sp = new URLSearchParams(location.search);
    return OWNED_PARAMS.some(function (p) { return sp.has(p); });
  }
  function markPushed() { didPushState = true; }

  /* ── recent searches ───────────────────────────────────────────────── */
  var recent = {
    list: function () { var l = IFX.storage.get("recent", []); return Array.isArray(l) ? l : []; },
    add: function (q, intent, extra) {
      var text = String(q || "").trim();
      if (!text) return;
      var list = recent.list().filter(function (r) { return !(r && r.q && r.q.toUpperCase() === text.toUpperCase()); });
      list.unshift(Object.assign({ q: text, intent: intent || "pn", at: Date.now() }, extra || {}));
      IFX.storage.set("recent", list.slice(0, RECENT_MAX));
    },
    clear: function () { IFX.storage.remove("recent"); },
  };

  /* ── saved parts ───────────────────────────────────────────────────── */
  var saved = {
    list: function () { var l = IFX.storage.get("saved", []); return Array.isArray(l) ? l : []; },
    has: function (id) { return saved.list().some(function (s) { return s && s.id === id; }); },
    toggle: function (item) {
      var list = saved.list();
      var idx = list.findIndex(function (s) { return s && s.id === item.id; });
      var on;
      if (idx >= 0) { list.splice(idx, 1); on = false; }
      else { list.unshift({ id: item.id, brand: item.brand, partNumber: item.partNumber, boreMm: item.boreMm, odMm: item.odMm, widthMm: item.widthMm, at: Date.now() }); on = true; }
      IFX.storage.set("saved", list.slice(0, SAVED_MAX));
      return on;
    },
    remove: function (id) {
      IFX.storage.set("saved", saved.list().filter(function (s) { return !(s && s.id === id); }));
    },
    clear: function () { IFX.storage.remove("saved"); },
  };

  /* ── preferences ───────────────────────────────────────────────────── */
  var prefs = {
    get: function (key, fallback) { return IFX.storage.get("pref:" + key, fallback); },
    set: function (key, value) { IFX.storage.set("pref:" + key, value); },
  };

  var state = {
    OWNED_PARAMS: OWNED_PARAMS,
    read: read,
    write: write,
    restore: restore,
    onPop: onPop,
    hasOwnedParams: hasOwnedParams,
    markPushed: markPushed,
    isRestoring: function () { return restoring; },
    recent: recent,
    saved: saved,
    prefs: prefs,
  };
  IFX.state = state;
  IFX.define("state", state);
})();
